import React, { useEffect, useRef, useState } from "react";
import { Row, Col } from "react-bootstrap";
import { FaTrash } from "react-icons/fa";
import { useSelector } from "react-redux";
import { useDownloadExcel } from "react-export-table-to-excel";
import Topbar from "../Topbar/Topbar";
import axios from "axios";
import "./Location.css";
import Swal from "sweetalert2";

export default function Location() {
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const permission = useSelector((state) => state.permissions);
    const designation = useSelector((state) => state.designation);
  const staffId = useSelector((state) => state.id);
  const role = useSelector((state) => state.roleName);
    const tableRef = useRef(null);
  const { onDownload } = useDownloadExcel({
    currentTableRef: tableRef.current,
    filename: "Location_data",
    sheet: "Location",
  });
  const today = new Date();
  const [selected, setSelected] = useState(""); // Super Admin dropdown value
  const [selectedMonth, setSelectedMonth] = useState(
    `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, "0")}`
  );
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [staffName, setStaffName] = useState([]);
  const [locationNames, setLocationNames] = useState({});

  // 🔵 Fetch Staff list for Super Admin
  useEffect(() => {
    const fetchStaff = async () => {
      try {
        const res = await axios.get(`${apiUrl}/get-staff-names`);
        const staffList = res.data.message
          .filter((s) => s.staffName && s._id)
          .map((s) => ({
            name: s.staffName,
            id: s._id,
          }));

        setStaffName(staffList);
      } catch (err) {
        console.error("Error fetching staff names:", err);
      }
    };

    fetchStaff();
  }, []);

  // 🔵 Handle Staff Dropdown Change
  const handleChange = (e) => {
    setSelected(e.target.value);
  };

  // 🔵 Fetch Activities (on page load or when Generate clicked)
  // const fetchActivities = async (customStaffId) => {
  //   const [year, month] = selectedMonth.split("-");
  //   const usedStaffId = customStaffId || staffId;

  //   setLoading(true);
  //   try {
  //     const response = await axios.get(`${apiUrl}/attendance/activities`, {
  //       params: {
  //         staffId: usedStaffId,
  //         month,
  //         year,
  //       },
  //     });

  //     const groupedData = {};

  //     response.data.forEach((item) => {
  //       const dt = new Date(item.date);
  //       const dateKey = dt.toLocaleDateString("en-GB");
  //       const time = dt.toLocaleTimeString("en-US", {
  //         hour: "2-digit",
  //         minute: "2-digit",
  //       });

  //       if (!groupedData[dateKey]) {
  //         groupedData[dateKey] = {
  //           date: dateKey,
  //           time: {},
  //           activity: "",
  //           location: item.location,
  //           address: "To be integrated",
  //         };
  //       }

  //       if (item.activity === "In") {
  //         groupedData[dateKey].time.In = time;
  //       } else if (item.activity === "Out") {
  //         groupedData[dateKey].time.Out = time;
  //       }

  //       groupedData[dateKey].activity += item.activity + " ";
  //     });

  //     const formattedData = Object.values(groupedData);
  //     setTableData(formattedData);
  //   } catch (err) {
  //     console.error("Error loading activity data:", err);
  //   } finally {
  //     setLoading(false);
  //   }
  // };
  const fetchActivities = async (customStaffId) => {
    const [year, month] = selectedMonth.split("-");
    const usedStaffId = customStaffId || staffId;

    setLoading(true);
    try {
      const response = await axios.get(`${apiUrl}/attendance/activities`, {
        params: {
          staffId: usedStaffId,
          month,
          year,
        },
      });

      const formattedData = response.data.map((item) => {
        const dt = new Date(item.date);
        return {
          date: dt.toLocaleDateString("en-GB"),
          time: dt.toLocaleTimeString("en-US", {
            hour: "2-digit",
            minute: "2-digit",
          }),
          activity: item.activity,
          location: item.location,
          address: "To be integrated",
        };
      });

      setTableData(formattedData);
    } catch (err) {
      console.error("Error loading activity data:", err);
    } finally {
      setLoading(false);
    }
  };

  // 🔵 On Page Load – Show current staff's data
  useEffect(() => {
    if (role !== "Super Admin") {
      fetchActivities(staffId); // Default fetch for logged-in staff
    }
  }, [staffId, selectedMonth]);

  // 🔘 Generate button – for both roles
  const handleGenerate = () => {
    const usedStaffId = role === "Super Admin" && selected ? selected : staffId;
    fetchActivities(usedStaffId);
  };

  const getDisplayNameFromCoordinates = async (lat, lng) => {
    if (!lat || !lng) {
      return "-";
    }

    try {
      const response = await fetch(
        `https://nominatim.openstreetmap.org/reverse?lat=${lat}&lon=${lng}&format=json`
      );

      if (!response.ok) {
        throw new Error("Failed to fetch location data");
      }

      const data = await response.json();
      return data.display_name || "-";
    } catch (error) {
      console.error("Error:", error);
      return "-";
    }
  };
  //Export PopUp
  const [shouldExport, setShouldExport] = useState(false);

  const handleExportConfirmation = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to export the Location details?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, export it!",
      cancelButtonText: "No, cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        onDownload();
        setShouldExport(true); // Allow the export to proceed
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire("Cancelled", "The export operation was cancelled.", "error");
        setShouldExport(false);
      }
    });
  };
  return (
    <div>
      <Topbar />
      <div className="container">
        <h3>Location</h3>

        {/* Filter row */}
        <Row className="row-btn mt-5 mb-5">
          {/* Staff dropdown for Super Admin */}
          <Col sm={12} md={3}>
            {role === "Super Admin" && (
              <select
                className="attendance-date"
                value={selected}
                onChange={handleChange}
                style={{ backgroundColor: "#EEF7FF" }}
              >
                <option value="">Select Staff</option>
                {staffName.map((staff) => (
                  <option key={staff.id} value={staff.id}>
                    {staff.name}
                  </option>
                ))}
              </select>
            )}
        
          </Col>

          {/* Month picker */}
          <Col sm={12} md={3} >
            <input
              type="month"
              className="form-control attendance-date ms-0"
              value={selectedMonth}
              onChange={(e) => {
                const value = e.target.value;
                if (!value) {
                  // If cleared, reset to current month
                  const current = new Date().toISOString().slice(0, 7);
                  setSelectedMonth(current);
                } else {
                  setSelectedMonth(value);
                }
              }}
            />
          </Col>

          {/* Generate button */}
          <Col sm={12} md={2} className="text-left">
            <button className="staff-generate-btn mb-5" onClick={handleGenerate}>
              Generate
            </button>
          </Col>

          {/* Refresh + Export */}
          <Col className="row-btn2 align-items-center text-end" sm={12} md={3}>
            <button
              className="black-btn me-5 mb-5"
              onClick={() => window.location.reload()}
            >
              Refresh
            </button>
            {/* {permission?.Location?.["Location Module"]?.Read && (
                <button
                  className="black-btn mb-5"
                  onClick={
                    designation === "Super Admin" && tableData.length > 0
                      ? handleExportConfirmation
                      : undefined
                  }
                  disabled={
                    designation !== "Super Admin" || tableData.length === 0
                  }
                  style={{
                    opacity:
                      designation === "Super Admin" && tableData.length > 0,
                    cursor:
                      designation === "Super Admin" && tableData.length > 0
                        ? "pointer"
                        : "not-allowed",
                  }}
                  title={
                    designation !== "Super Admin"
                      ? "Only Super Admin can export"
                      : tableData.length === 0
                      ? "No data to export"
                      : "Export"
                  }
                >
                  Export
                </button>
            )} */}
          </Col>
        </Row>

        {/* Table */}
        <div className="scrolltable">
          <table className="table table-bordered" ref={tableRef}>
            <thead className="table-th text-center">
              <tr>
                <th style={{ width: "15%" }}>Date</th>
                <th style={{ width: "15%" }}>Time</th>
                <th style={{ width: "15%" }}>Activity</th>
                <th style={{ width: "35%" }}>Address</th>
                <th style={{ width: "15%" }}>Latitude</th>
                <th style={{ width: "15%" }}>Longitude</th>
                {/* <th>Delete</th> */}
              </tr>
            </thead>
            <tbody>
              {permission?.Location?.["Location Module"]?.Read &&
                (tableData.length > 0 ? (
                  tableData.map((item, index) => {
                    const key = `${item.location.latitude},${item.location.longitude}`;
                    if (!locationNames[key]) {
                      getDisplayNameFromCoordinates(
                        item.location.latitude,
                        item.location.longitude
                      ).then((name) => {
                        setLocationNames((prev) => ({
                          ...prev,
                          [key]: name,
                        }));
                      });
                    }

                    return (
                      <tr key={index}>
                        <td className="text-center">{item.date}</td>
                        <td className="text-center">{item.time}</td>
                        <td className="text-center">{item.activity}</td>
                        <td className="text-center">
                          {locationNames[key] || "Loading..."}
                        </td>
                        <td className="text-center">
                          {item.location.latitude}
                        </td>
                        <td className="text-center">
                          {item.location.longitude}
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan="6" className="text-center">
                      No data found
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
